import React, { useState, useCallback, useMemo } from "react";
import { Flex, Button } from "antd";
import BubbleChart from "Components/SbBubbleChart/customBubbleChart";
import SbButton from "uiCore/SbButton/SbButton";
import { BUTTON_TYPE_PRIMARY } from "constants/ui.constants";
import { TEXT, TOP_SKILLS_COUNT } from "../../SbSkillsMapV2.constants";
import {
  ChartHeaderStyled,
  ChartTitleStyled,
  ChartSubtitleStyled,
  BubbleChartWrapperStyled,
  SkillsDetectedStyled,
  FootnoteTextStyled,
} from "./SkillsChart.styles";

const SkillsChart = ({ skills, title, subtitle }) => {
  const [visibleCount, setVisibleCount] = useState(TOP_SKILLS_COUNT);

  const skillsToShow = useMemo(
    () => skills.slice(0, visibleCount),
    [skills, visibleCount]
  );

  const handleAdd = useCallback(
    () => setVisibleCount((prev) => Math.min(skills.length, prev + TOP_SKILLS_COUNT)),
    [skills.length]
  );

  const handleRemove = useCallback(
    () => setVisibleCount((prev) => Math.max(TOP_SKILLS_COUNT, prev - TOP_SKILLS_COUNT)),
    []
  );

  const isAtMin = visibleCount <= TOP_SKILLS_COUNT;
  const isAtMax = visibleCount >= skills.length;

  return (
    <Flex vertical gap={6}>

      <ChartHeaderStyled>
        <ChartTitleStyled level={4}>{title}</ChartTitleStyled>
        <ChartSubtitleStyled type="secondary">{subtitle}</ChartSubtitleStyled>
      </ChartHeaderStyled>

      <BubbleChartWrapperStyled vertical align="center">
        <BubbleChart skills={skillsToShow} />
        <SkillsDetectedStyled>
          {TEXT.SKILLS_DETECTED_PREFIX}{skills.length}
        </SkillsDetectedStyled>
      </BubbleChartWrapperStyled>

      <Flex align="flex-end" justify="space-between" gap={16}>
        <Flex vertical gap={4} flex={1}>
          <FootnoteTextStyled type="secondary">{TEXT.FOOTNOTE_IMPORTANCE}</FootnoteTextStyled>
          <FootnoteTextStyled type="secondary">{TEXT.FOOTNOTE_SKILLS_REQUIRED}</FootnoteTextStyled>
          <FootnoteTextStyled type="secondary">{TEXT.FOOTNOTE_SBI}</FootnoteTextStyled>
        </Flex>
        {/* <SbButton buttonType={BUTTON_TYPE_PRIMARY}>
          {TEXT.BTN_VIEW_ALL}
        </SbButton> */}
        <Button.Group>
          <SbButton buttonType={BUTTON_TYPE_PRIMARY} onClick={handleRemove} disabled={isAtMin}>
            −
          </SbButton>
          <SbButton buttonType={BUTTON_TYPE_PRIMARY} onClick={handleAdd} disabled={isAtMax}>
            +
          </SbButton>
        </Button.Group>
      </Flex>

    </Flex>
  );
};

export default SkillsChart;
